import React, { Fragment } from 'react';
import { wrapExpressionForRender } from '../../../utils/react-utils';

export interface IfProps {
  test: boolean | unknown;
  component?;
}

const If: React.FC<IfProps> = ({
  test,
  children,
  component: ChildComponent,
  ...restProps
}) => {
  if (!test) {
    return <Fragment />;
  }

  return ChildComponent ? (
    <ChildComponent {...restProps} />
  ) : (
    wrapExpressionForRender(children)
  );
};
export default If;
